import React from 'react';
import {
  arrayOf, shape, number, node
} from 'prop-types';
import '../../themeDefaults';
import BarSegment from './BarSegment';
import useStyles from './ColorBar.styles';

const ColorBar = ({
  children, segments, total, ...rest
}) => {
  const classes = useStyles({ ...rest });
  return (
    <div className={classes.root}>
      {children || segments.map((segment, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <BarSegment color={segment.color} amount={segment.amount} key={index} total={total} />
      ))}
    </div>
  );
};

ColorBar.propTypes = {
  children: node,
  height: number,
  segments: (props, ...rest) => (props.children ? null
    : arrayOf(shape(BarSegment.propTypes)).isRequired(props, ...rest)),
  total: number
};

ColorBar.defaultProps = {
  children: undefined,
  height: 6,
  segments: undefined,
  total: undefined
};

export default ColorBar;
